import { Roarr } from 'roarr';

export const logger = Roarr.child({
  application: 'contra-web-app',
});
